/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* Mostrar SKU en el buscador predictivo */
(function () {
  try {
    var cache = {};
    function skuFor(handle) {
      if (cache[handle]) return cache[handle];
      return (cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var s = (p.variants || []).map(function (v) { return v.sku; }).filter(Boolean);
          if (!s.length) return '';
          return s.length === 1 ? s[0] : s[0] + ' (+' + (s.length - 1) + ' más)';
        })
        .catch(function () { return ''; }));
    }
    function decorate(root) {
      root.querySelectorAll('a.search-bar__result-item:not(.search-bar__result-item--skeleton)').forEach(function (a) {
        if (a.dataset.skuDone) return;
        a.dataset.skuDone = '1';
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        skuFor(m[1]).then(function (sku) {
          if (!sku) return;
          var info = a.querySelector('.search-bar__item-info');
          if (!info) return;
          var el = document.createElement('span');
          el.className = 'search-bar__item-sku';
          el.textContent = 'SKU: ' + sku;
          el.style.cssText = 'display:block;font-size:12px;font-weight:600;letter-spacing:.02em;opacity:.75;margin-top:2px';
          var title = info.querySelector('.search-bar__item-title');
          (title || info).insertAdjacentElement(title ? 'afterend' : 'beforeend', el);
        });
      });
    }
    function init() {
      document.querySelectorAll('.search-bar__results').forEach(function (box) {
        if (box.dataset.skuObs) return;
        box.dataset.skuObs = '1';
        new MutationObserver(function () { decorate(box); }).observe(box, { childList: true, subtree: true });
        decorate(box);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) {}
})();